// - - START - -
// This is an auto generated file
// - - - - - -

// Import components
import copytoclipboard_en from 'components/CopyToClipboard/locale/en.locale';
import copytoclipboard_ja from 'components/CopyToClipboard/locale/ja.locale';
import form_fileuploader_en from 'components/Form/FileUploader/locale/en.locale';
import form_fileuploader_ja from 'components/Form/FileUploader/locale/ja.locale';
import form_inputincremental_en from 'components/Form/InputIncremental/locale/en.locale';
import form_inputincremental_ja from 'components/Form/InputIncremental/locale/ja.locale';
import layout_dualpage_ricohbanner_en from 'components/Layout/DualPage/RicohBanner/locale/en.locale';
import layout_dualpage_ricohbanner_ja from 'components/Layout/DualPage/RicohBanner/locale/ja.locale';
import navigation_navigationtabs_en from 'components/Navigation/NavigationTabs/locale/en.locale';
import navigation_navigationtabs_ja from 'components/Navigation/NavigationTabs/locale/ja.locale';
import table_tablecomponents_tablepagination_en from 'components/Table/TableComponents/TablePagination/locale/en.locale';
import table_tablecomponents_tablepagination_ja from 'components/Table/TableComponents/TablePagination/locale/ja.locale';
import form_complex_en from 'examples/Form/Complex/locale/en.locale';
import form_complex_ja from 'examples/Form/Complex/locale/ja.locale';
import form_simple_en from 'examples/Form/Simple/locale/en.locale';
import form_simple_ja from 'examples/Form/Simple/locale/ja.locale';
import common_en from 'locale/common/en.locale';
import common_ja from 'locale/common/ja.locale';
import form_en from 'locale/form/en.locale';
import form_ja from 'locale/form/ja.locale';
import billing_planchange_tabnavigation_en from 'pages/Billing/PlanChange/TabNavigation/locale/en.locale';
import billing_planchange_tabnavigation_ja from 'pages/Billing/PlanChange/TabNavigation/locale/ja.locale';
import clients_client_contact_en from 'pages/Clients/Client/Contact/locale/en.locale';
import clients_client_contact_ja from 'pages/Clients/Client/Contact/locale/ja.locale';
import clients_client_sendingsettings_en from 'pages/Clients/Client/SendingSettings/locale/en.locale';
import clients_client_sendingsettings_ja from 'pages/Clients/Client/SendingSettings/locale/ja.locale';
import document_conversionsettings_bytype_en from 'pages/Document/ConversionSettings/ByType/locale/en.locale';
import document_conversionsettings_bytype_ja from 'pages/Document/ConversionSettings/ByType/locale/ja.locale';
import document_conversionsettings_root_en from 'pages/Document/ConversionSettings/Root/locale/en.locale';
import document_conversionsettings_root_ja from 'pages/Document/ConversionSettings/Root/locale/ja.locale';
import document_en from 'pages/Document/locale/en.locale';
import document_ja from 'pages/Document/locale/ja.locale';
import document_pdffilenamesettings_en from 'pages/Document/PdfFilenameSettings/locale/en.locale';
import document_pdffilenamesettings_ja from 'pages/Document/PdfFilenameSettings/locale/ja.locale';
import document_taxregistrationnumberdisplay_en from 'pages/Document/TaxRegistrationNumberDisplay/locale/en.locale';
import document_taxregistrationnumberdisplay_ja from 'pages/Document/TaxRegistrationNumberDisplay/locale/ja.locale';
import partner_integrations_ricohdirectdebit_en from 'pages/Partner/Integrations/RicohDirectDebit/locale/en.locale';
import partner_integrations_ricohdirectdebit_ja from 'pages/Partner/Integrations/RicohDirectDebit/locale/ja.locale';
import partner_integrations_ricohtradeautomation_en from 'pages/Partner/Integrations/RicohTradeAutomation/locale/en.locale';
import partner_integrations_ricohtradeautomation_ja from 'pages/Partner/Integrations/RicohTradeAutomation/locale/ja.locale';
import partner_tagssettings_en from 'pages/Partner/TagsSettings/locale/en.locale';
import partner_tagssettings_ja from 'pages/Partner/TagsSettings/locale/ja.locale';
import portal_en from 'pages/Portal/locale/en.locale';
import portal_ja from 'pages/Portal/locale/ja.locale';
import staff_customtemplatesearch_en from 'pages/Staff/CustomTemplateSearch/locale/en.locale';
import staff_customtemplatesearch_ja from 'pages/Staff/CustomTemplateSearch/locale/ja.locale';

const resources = {
    en: {
        'Billing.PlanChange.TabNavigation': billing_planchange_tabnavigation_en,
        'Clients.Client.Contact': clients_client_contact_en,
        'Clients.Client.SendingSettings': clients_client_sendingsettings_en,
        common: common_en,
        CopyToClipboard: copytoclipboard_en,
        Document: document_en,
        'Document.ConversionSettings.ByType':
            document_conversionsettings_bytype_en,
        'Document.ConversionSettings.Root': document_conversionsettings_root_en,
        'Document.PdfFilenameSettings': document_pdffilenamesettings_en,
        'Document.TaxRegistrationNumberDisplay':
            document_taxregistrationnumberdisplay_en,
        form: form_en,
        'Form.Complex': form_complex_en,
        'Form.FileUploader': form_fileuploader_en,
        'Form.InputIncremental': form_inputincremental_en,
        'Form.Simple': form_simple_en,
        'Layout.DualPage.RicohBanner': layout_dualpage_ricohbanner_en,
        'Navigation.NavigationTabs': navigation_navigationtabs_en,
        'Partner.Integrations.RicohDirectDebit':
            partner_integrations_ricohdirectdebit_en,
        'Partner.Integrations.RicohTradeAutomation':
            partner_integrations_ricohtradeautomation_en,
        'Partner.TagsSettings': partner_tagssettings_en,
        Portal: portal_en,
        'Staff.CustomTemplateSearch': staff_customtemplatesearch_en,
        'Table.TableComponents.TablePagination':
            table_tablecomponents_tablepagination_en,
    },
    ja: {
        'Billing.PlanChange.TabNavigation': billing_planchange_tabnavigation_ja,
        'Clients.Client.Contact': clients_client_contact_ja,
        'Clients.Client.SendingSettings': clients_client_sendingsettings_ja,
        common: common_ja,
        CopyToClipboard: copytoclipboard_ja,
        Document: document_ja,
        'Document.ConversionSettings.ByType':
            document_conversionsettings_bytype_ja,
        'Document.ConversionSettings.Root': document_conversionsettings_root_ja,
        'Document.PdfFilenameSettings': document_pdffilenamesettings_ja,
        'Document.TaxRegistrationNumberDisplay':
            document_taxregistrationnumberdisplay_ja,
        form: form_ja,
        'Form.Complex': form_complex_ja,
        'Form.FileUploader': form_fileuploader_ja,
        'Form.InputIncremental': form_inputincremental_ja,
        'Form.Simple': form_simple_ja,
        'Layout.DualPage.RicohBanner': layout_dualpage_ricohbanner_ja,
        'Navigation.NavigationTabs': navigation_navigationtabs_ja,
        'Partner.Integrations.RicohDirectDebit':
            partner_integrations_ricohdirectdebit_ja,
        'Partner.Integrations.RicohTradeAutomation':
            partner_integrations_ricohtradeautomation_ja,
        'Partner.TagsSettings': partner_tagssettings_ja,
        Portal: portal_ja,
        'Staff.CustomTemplateSearch': staff_customtemplatesearch_ja,
        'Table.TableComponents.TablePagination':
            table_tablecomponents_tablepagination_ja,
    },
};
export default resources;
